var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auth"},[_vm._m(0),_c('div',{staticClass:"auth-container fixed-top"},[_c('Login')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auth-screen fixed-top"},[_c('div',{staticClass:"auth-screen-background"},[_c('div',{staticClass:"auth-screen-background-square"})])])
}]

export { render, staticRenderFns }